/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { BillingEntitiesPaginatedResponse } from '../model/billingEntitiesPaginatedResponse';
// @ts-ignore
import { BillingEntityPatchSpec } from '../model/billingEntityPatchSpec';
// @ts-ignore
import { BillingEntityPostSpec } from '../model/billingEntityPostSpec';
// @ts-ignore
import { BillingEntityResponse } from '../model/billingEntityResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingEntityOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Delete the entity from billing
     * Delete the entity for billing
     * @param billingEntityQueryId Billing Entity Primary Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteBillingEntity(billingEntityQueryId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingEntityResponse>;
    public deleteBillingEntity(billingEntityQueryId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingEntityResponse>>;
    public deleteBillingEntity(billingEntityQueryId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingEntityResponse>>;
    public deleteBillingEntity(billingEntityQueryId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (billingEntityQueryId === null || billingEntityQueryId === undefined) {
            throw new Error('Required parameter billingEntityQueryId was null or undefined when calling deleteBillingEntity.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingEntityQueryId, 'billing-entity-query-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/entity`;
        return this.httpClient.request<BillingEntityResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all entities registered for billing
     * Get all entities registered for billing by optional filters
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the billing entity by this column
     * @param billingEntityOptionalQueryId Billing Entity Primary Id In Optional Filter
     * @param orgId organization identifier in optional filter
     * @param serviceType Service Type
     * @param vcdsServiceType VCDS Service Type
     * @param entityId Entity UUID
     * @param billingState Billing state
     * @param bucketAccount bucket account
     * @param bucketName bucket name
     * @param bucketMode Bucket mode
     * @param billingMode Billing mode
     * @param generationCount Billing register generation count
     * @param cloudProvider Cloud provider
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllBillingEntities(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'serviceType' | 'vcdsServiceType' | 'billingState' | 'cloudProvider' | 'startTs' | 'lastBilledTs' | 'createdTs' | 'updatedTs', billingEntityOptionalQueryId?: number, orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', entityId?: string, billingState?: 'STARTED' | 'STOPPING' | 'STOPPED', bucketAccount?: string, bucketName?: string, bucketMode?: 'INDIVIDUAL' | 'SHARED', billingMode?: 'TRIAL' | 'REGULAR', generationCount?: number, cloudProvider?: 'AWS' | 'GCP', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingEntitiesPaginatedResponse>;
    public getAllBillingEntities(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'serviceType' | 'vcdsServiceType' | 'billingState' | 'cloudProvider' | 'startTs' | 'lastBilledTs' | 'createdTs' | 'updatedTs', billingEntityOptionalQueryId?: number, orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', entityId?: string, billingState?: 'STARTED' | 'STOPPING' | 'STOPPED', bucketAccount?: string, bucketName?: string, bucketMode?: 'INDIVIDUAL' | 'SHARED', billingMode?: 'TRIAL' | 'REGULAR', generationCount?: number, cloudProvider?: 'AWS' | 'GCP', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingEntitiesPaginatedResponse>>;
    public getAllBillingEntities(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'serviceType' | 'vcdsServiceType' | 'billingState' | 'cloudProvider' | 'startTs' | 'lastBilledTs' | 'createdTs' | 'updatedTs', billingEntityOptionalQueryId?: number, orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', entityId?: string, billingState?: 'STARTED' | 'STOPPING' | 'STOPPED', bucketAccount?: string, bucketName?: string, bucketMode?: 'INDIVIDUAL' | 'SHARED', billingMode?: 'TRIAL' | 'REGULAR', generationCount?: number, cloudProvider?: 'AWS' | 'GCP', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingEntitiesPaginatedResponse>>;
    public getAllBillingEntities(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'serviceType' | 'vcdsServiceType' | 'billingState' | 'cloudProvider' | 'startTs' | 'lastBilledTs' | 'createdTs' | 'updatedTs', billingEntityOptionalQueryId?: number, orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', entityId?: string, billingState?: 'STARTED' | 'STOPPING' | 'STOPPED', bucketAccount?: string, bucketName?: string, bucketMode?: 'INDIVIDUAL' | 'SHARED', billingMode?: 'TRIAL' | 'REGULAR', generationCount?: number, cloudProvider?: 'AWS' | 'GCP', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllBillingEntities.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getAllBillingEntities.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingEntityOptionalQueryId, 'billing-entity-optional-query-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>entityId, 'entity-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingState, 'billing-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>bucketAccount, 'bucket-account');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>bucketName, 'bucket-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>bucketMode, 'bucket-mode');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingMode, 'billing-mode');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>generationCount, 'generation-count');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/entity`;
        return this.httpClient.request<BillingEntitiesPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch the billing entity
     * Patch the billing entity
     * @param billingEntityQueryId Billing Entity Primary Id
     * @param billingEntityPatchSpec Billing entity patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchBillingEntity(billingEntityQueryId: number, billingEntityPatchSpec: BillingEntityPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingEntityResponse>;
    public patchBillingEntity(billingEntityQueryId: number, billingEntityPatchSpec: BillingEntityPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingEntityResponse>>;
    public patchBillingEntity(billingEntityQueryId: number, billingEntityPatchSpec: BillingEntityPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingEntityResponse>>;
    public patchBillingEntity(billingEntityQueryId: number, billingEntityPatchSpec: BillingEntityPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (billingEntityQueryId === null || billingEntityQueryId === undefined) {
            throw new Error('Required parameter billingEntityQueryId was null or undefined when calling patchBillingEntity.');
        }
        if (billingEntityPatchSpec === null || billingEntityPatchSpec === undefined) {
            throw new Error('Required parameter billingEntityPatchSpec was null or undefined when calling patchBillingEntity.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingEntityQueryId, 'billing-entity-query-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/entity`;
        return this.httpClient.request<BillingEntityResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: billingEntityPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Register the entity for billing
     * Register the entity for billing
     * @param billingEntityPostSpec Billing entity registration spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public registerBillingEntity(billingEntityPostSpec: BillingEntityPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingEntityResponse>;
    public registerBillingEntity(billingEntityPostSpec: BillingEntityPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingEntityResponse>>;
    public registerBillingEntity(billingEntityPostSpec: BillingEntityPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingEntityResponse>>;
    public registerBillingEntity(billingEntityPostSpec: BillingEntityPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (billingEntityPostSpec === null || billingEntityPostSpec === undefined) {
            throw new Error('Required parameter billingEntityPostSpec was null or undefined when calling registerBillingEntity.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/entity`;
        return this.httpClient.request<BillingEntityResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: billingEntityPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
